module.exports = __webpack_public_path__ + "sy.svg?fce5d4b9abdc1893f95cffc4eabd39da";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sy.svg
// module id = 1194
// module chunks = 27